import gql from 'graphql-tag'

export const WISHLIST_FRAGMENT = gql`
  fragment WishlistFragment on WishList {
    id
    totalCount
    title
    note
    isPublic
    hash
    isMain
    items {
      id
      amount
      variant {
        id
        title
        variantUrl
        currency
        price
        priceRrp
        currencyAbbr
        mediaId
        isAvailable
        availability {
          key
          isAvailable
        }
      }
      product {
        id
        mainMenuUrlKey
      }
    }
  }
`

export const WISHLIST_BY_HASH_FRAGMENT = gql`
  fragment WishlistByHashFragment on WishListByHash {
    id
    totalCount
    title
    note
    isPublic
    isMain
    hash
    items {
      id
      amount
      variant {
        id
        title
        variantUrl
        currency
        price
        priceRrp
        currencyAbbr
        mediaId
        isAvailable
        availability {
          key
          isAvailable
        }
      }
      product {
        id
        mainMenuUrlKey
      }
    }
  }
`

export const GET_MAIN_WISH_LIST = gql`
  query {
    getMainWishList {
      ...WishlistFragment
    }
  }
  ${WISHLIST_FRAGMENT}
`

export const GET_WISH_LIST_BY_ID = gql`
  query($id: ID!) {
    getWishList(wishListId: $id) {
      ...WishlistFragment
    }
  }

  ${WISHLIST_FRAGMENT}
`

export const GET_WISH_LIST_BY_HASH = gql`
  query($hash: String!) {
    wishList: getWishListByHash(hash: $hash) {
      ...WishlistByHashFragment
    }
  }

  ${WISHLIST_BY_HASH_FRAGMENT}
`

export const GET_WISH_LISTS = gql`
  query wishLists {
    wishLists: getWishLists {
      ...WishlistFragment
    }
  }

  ${WISHLIST_FRAGMENT}
`

export const MUTATION_DELETE_WISH_LIST_ITEM = gql`
  mutation deleteWishListItem($wishListItemId: WishListItemIdInput!) {
    deleteWishListItem(wishListItemId: $wishListItemId) {
      ...WishlistFragment
    }
  }
  ${WISHLIST_FRAGMENT}
`

export const MUTATION_DELETE_WISH_LIST = gql`
  mutation deleteWishList($wishListId: ID!) {
    deleteWishList(wishListId: $wishListId)
  }
`

export const MUTATION_CREATE_WISH_LIST_ITEM = gql`
  mutation createWishListItem($wishList: WishListItemInput!) {
    createWishListItem(wishList: $wishList) {
      ...WishlistFragment
    }
  }
  ${WISHLIST_FRAGMENT}
`

export const MUTATION_CREATE_WISH_LIST = gql`
  mutation createWishList($wishList: WishListInput!) {
    createWishList(wishList: $wishList) {
      id
      title
      note
      isPublic
      isMain
      totalCount
    }
  }
`

export const MUTATION_UPDATE_WISH_LIST = gql`
  mutation updateWishList($wishList: WishListInput!, $wishListId: ID!) {
    updateWishList(whishList: $wishList, wishListId: $wishListId) {
      id
      title
      note
      isPublic
      isMain
      totalCount
      hash
    }
  }
`
